import React, { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import storage from 'core/storage'
import { useFeatures, useUpdate, useEventListener } from 'core/hooks'
import MessageRebill from './MessageRebill'
import {
  MessageUpgrade,
  MessageFreeChat,
  MessageLimit,
  TempMessage,
  MessageUpgradeCredits,
} from './SystemMessages'
import CONFIG from 'core/globals';

const BLOCK_TYPES = {
  BLOCK_REBILL: 'blockRebill',
  CONVERSATION_LIMIT_REACHED: 'conversationLimitReached',
}

function SystemMessagesContainer({ store, actions }) {
  const { conversationUid, conversation, user, anotherActiveConversation } = store
  const { showRecurringNotification, blockAfterInteraction, isCreditSite, useMessagesInsteadOfCredits } = useFeatures()

  // AVN-1396: during the free chat window messaging behaves as if the user had credits, so none of the
  // upgrade or out-of-credits prompts belong on screen.
  if (store.freeChatWindowActive) {
    return null
  }
  const renderUpgradeMessage = conversationBlock => {
    if (conversation?.wasTempUnblocked) {
      return null
    }
    if (conversation?.blockMessage?.message) {
      return <TempMessage text={conversation.blockMessage.message}/>
    }

    if (user?.secondBlock) {
      if (showRecurringNotification && user?.blockType === BLOCK_TYPES.BLOCK_REBILL) {
        return <MessageRebill conversationUid={conversationUid} rebillSucceeded={() => actions.user.markUserAsUnBlocked()}/>
      }
      if (user?.premium && user?.blockType === BLOCK_TYPES.CONVERSATION_LIMIT_REACHED) {
        return <MessageLimit/>
      }
      if (user?.secondBlock && conversation.isBlocked) {
        return isCreditSite ? <MessageUpgradeCredits useMessagesInsteadOfCredits={useMessagesInsteadOfCredits}/> : <MessageUpgrade/>
      }
    }

    if (!user?.premium && conversationBlock) {
      return isCreditSite ? <MessageUpgradeCredits useMessagesInsteadOfCredits={useMessagesInsteadOfCredits}/> : <MessageUpgrade/>
    }

    if (!user?.premium && anotherActiveConversation) {
      return isCreditSite ? <MessageUpgradeCredits useMessagesInsteadOfCredits={useMessagesInsteadOfCredits}/>  : <MessageFreeChat/>
    }
  }

  if (!user?.premium && (conversation.isBlocked || storage.get(`ccp-${CONFIG.userUid}-blocked-conversations`, []).includes(conversation.conversationUid))) {
    return renderUpgradeMessage(true)
  }
  //some block types override the blockAfterInteraction feature switch
  if (![BLOCK_TYPES.BLOCK_REBILL, BLOCK_TYPES.CONVERSATION_LIMIT_REACHED].includes(user?.blockType) && blockAfterInteraction) {
    return (storage.get(`ccp-${CONFIG.userUid}-interacted`, []).includes(conversation.conversationUid)) ? renderUpgradeMessage(false) : null
  }

  return renderUpgradeMessage(false)
}

export default inject('store', 'actions')(observer(SystemMessagesContainer))

export const TempSystemMessagesContainer = inject('store')(observer(({ store, scrollToBottom }) => {
  const { conversation } = store

  const [previousConversation, currentConversation ]= useUpdate(conversation)

  useEffect(() => {
    if (previousConversation !== currentConversation) {
      previousConversation?.removeTempMessage()
    }
  }, [previousConversation])

  useEffect(() => {
    setTimeout(scrollToBottom, 50)
  }, [currentConversation.tempMessages])

  useEventListener('click', e => currentConversation.tempMessages.forEach(m => {
    m.hideOnClick.forEach(selector => {
      if (e.target.closest(selector)) {
        currentConversation.removeTempMessage(m.message)
      }
    })
  }), [currentConversation.tempMessages], document.querySelector('.chat-widget'))

  return currentConversation.tempMessages.map(({  message, title }, index) => <TempMessage key={index} text={message} title={title}/>)
}))

